import { Globalize } from "./_globalize";
import { createElement, uniqueId, onEvent } from "./_dom";
import { registerComponent } from "./component";
// import { isMobile } from "./browser";
import { initPopupContainer, closePopup } from "./_menu";

class TimePicker {
	constructor(field/*, options*/) {
		this.#field = field;
		// this.#options = options;
		this.#init();
	}

	#onfocus = () => {
		if (!this.#field.hasAttribute("aria-controls")) {
			TimePicker.#ensureTimePopup();
			TimePicker.#onCloseTimePopup();
			this.#field.setAttribute("aria-controls", TimePicker.#timePopup.id);
			TimePicker.#currentField = this.#field;
			TimePicker.#setActiveItem(this.#field.value);
		}
	};

	#onblur = ({ relatedTarget }) => {
		if (TimePicker.#timePopup && !TimePicker.#timePopup.contains(relatedTarget)) {
			closePopup(TimePicker.#timePopup);
		}
	};

	static #onCloseTimePopup = () => {
		if (TimePicker.#currentField) {
			TimePicker.#currentField.removeAttribute("aria-controls");
			TimePicker.#currentField.removeAttribute("aria-expanded");
			TimePicker.#currentField = null;
		}
		TimePicker.#timePopup.popperInstance?.destroy();
		delete TimePicker.#timePopup.popperInstance;
	};

	#init() {
		const parent = this.#field.parentNode;
		parent.classList.add('v3-has-time');
		this.#field.classList.add("js-auto-popup", "v3-popup-trigger");
		this.#field.setAttribute("aria-haspopup", "true");
		this.#field.setAttribute("data-popper-placement", "bottom");
		this.#field.addEventListener("focus", this.#onfocus);
		this.#field.addEventListener("blur", this.#onblur);
		this.#field.addEventListener("v3-popup.close", TimePicker.#onCloseTimePopup);
	}

	static #setActiveItem(value) {
		const parsedValue = Globalize.parseDate(value);
		if (parsedValue?.getSeconds() === 0) {
			// no seconds? format
			const formattedValue = Globalize.format(parsedValue, "t");
			const oldActiveItem = TimePicker.#timePopup.querySelector('.v3-menu__item--active');
			oldActiveItem?.classList.remove("v3-menu__item--active");
			const newActiveItem = [...TimePicker.#timePopup.querySelectorAll('.v3-menu__item')].find(item => item.innerText === formattedValue);
			newActiveItem?.classList.add("v3-menu__item--active");
		}
	}

	static #onclickmenuitem = (event, item) => {
		const field = TimePicker.#currentField;
		event.preventDefault();
		const timePopup = TimePicker.#timePopup;
		const current = timePopup.querySelector('.v3-menu__item--active');
		if (current) current.classList.remove('v3-menu__item--active');
		item.classList.add('v3-menu__item--active');
		const newValue = item.innerText;
		closePopup(timePopup);
		if (field.value !== newValue) {
			field.value = newValue;
			field.dispatchEvent(new Event("change", { bubbles: true }));
		}
	};

	static #createDropdownItems(intervalMinutes) {
		return [...Array((24 * 60 / intervalMinutes) | 0).keys()].map(k =>
			createElement("li", { class: "v3-menu__cell", role: "none" },
				createElement("a", { href: "#", tabindex: "-1", role: "menuitem", class: "v3-menu__item", }, Globalize.format(new Date(2000, 1, 1, 0, k * intervalMinutes, 0), "t"))));
	}

	static #ensureTimePopup() {
		if (!TimePicker.#timePopup) {
			Globalize.culture(); // init culture by requesting it
			const timePopup = createElement("ul", {
					id: uniqueId("v3-time-popup"),
					class: "v3-timepicker-menu v3-menu-scrollable v3-menu v3-popup",
					role: "menu",
				},
				...TimePicker.#createDropdownItems(TimePicker.intervalMinutes)
			);
			const container = initPopupContainer();
			container.append(timePopup);
			onEvent(timePopup, ".v3-menu__item", "click", TimePicker.#onclickmenuitem);
			TimePicker.#timePopup = timePopup;
		}
	}

	static create(field, options) {
		return new TimePicker(field, options);
	}

	/** @type {HTMLInputElement}*/#field;
	///** @type {Object}*/#options;
	/** @type {HTMLInputElement}*/static #currentField;
	/** @type {HTMLDivElement}*/static #timePopup;
	static intervalMinutes = 60;
}

const timepicker = registerComponent(TimePicker.create);


function init(context, selector = "input.v3-input-time") {
	return timepicker(selector, context);
}

export { timepicker, TimePicker, init };